module.exports = __webpack_public_path__ + "static/media/tti_weekly_offers@2x.4d532ad2.png";